/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { BuscarAssoc , EnviarEmail } from '../../services/associados';
import { insereInscricao } from '../../services/inscricao';
import { Message } from 'primereact/message';
import moment from 'moment';
import PDF from './pdf-comprovante';
import { showMessageSuccess } from '../others/toastr';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import comprovanteAdesao from '../assinatura/infra/comprovanteAdesao';

const ValorAdesaoDinheiro = props => {
    const [isDialog, setDialog] = useState(true);
    const [isProgress, setProgress] = useState(true);
    const [associado, setAssociado] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [erro, setErro] = useState(false);
    const [loadingEmail, setLoadingEmail] = useState(false);
    const [valuePdf, setValuePdf] = useState(false);

    const nomeVendedor = decriptoLocalStorage('Nome')?.decriptoValue;
    const Valor = props.valor;
    const Inscricao = props.inscricao;

    const [isAdesao, setAdesao] = useState(Valor);
    const { subGrupo } = props;

    const formatCurrency = value => value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });

    useEffect(() => {
        async function loadAssociado() {
            await BuscarAssoc(Inscricao)
                .then(response => {
                    setAssociado(response[0]);
                })
                .catch(err => {
                    alert(err);
                });
        }

        loadAssociado();
    }, []);

    let subGrupoZI;
    let adesaoValor;

    if (subGrupo === 'ZI   ') {
        subGrupoZI = true;
        adesaoValor = 0;
    } else {
        subGrupoZI = false;
        adesaoValor = isAdesao;
    }

    const { Nome, AssEmail, Cidade, UF } = { ...associado };
    const ValorPago = subGrupo === 'ZI   ' ? 120 : formatCurrency(isAdesao);

    async function enviarEmail() {
        setLoadingEmail(true);

        const body = {
            nome: Nome,
            email: AssEmail,
            valor: ValorPago,
            data: moment().format('DD/MM/YYYY'),
            numero_contrato: `${Inscricao  }`,
            uf: UF,
            cidade: Cidade,
            forma_envio: '',
            responsavel_receber: nomeVendedor
        };

        await EnviarEmail(body)
            .then(resp => {
                if (resp.status === 200) {
                    setLoadingEmail(false);
                    setSucesso(true);
                }
            })
            .catch(err => {
                console.log(err);
                setErro(true);
                setLoadingEmail(false);
            });
    }

    const setValorAdesao = async () => {
        if (isAdesao) {
            setProgress(false);

            const Pagamento = null;
            const tipoPagamento = 'Dinheiro';

            await insereInscricao({
                Inscricao,
                Valor,
                Pagamento,
                tipoPagamento
            })
                .then(response => {
                    setProgress(true);
                    setDialog(false);
                    showMessageSuccess(
                        'Sucesso',
                        'Valor da Adesao inserido com sucesso'
                    );
                })
                .catch(error => {
                    console.error(error);
                });
        }
    };

    let bodyPdf = {};

    if (associado) {
        bodyPdf = {
            nome: Nome,
            valor: ValorPago,
            data: moment().format('DD/MM/YYYY'),
            numero_contrato: `${Inscricao  }`,
            cidade: Cidade,
            responsavel_receber: nomeVendedor
        };
    }

    async function buscarPdf() {
        const bodyRequest = {
            nome: Nome,
            email: AssEmail,
            valor: ValorPago,
            data: moment().format('DD/MM/YYYY'),
            numero_contrato: `${Inscricao  }`,
            uf: UF,
            cidade: Cidade,
            forma_envio: '',
            responsavel_receber: nomeVendedor
        };

        await comprovanteAdesao.geraComprovanteAdesaoController(bodyRequest);
    }

    const footer = (
        <div>
            <Button
                label="Confirmar"
                icon="pi pi-check"
                className="p-button-success"
                onClick={setValorAdesao}
                disabled={subGrupoZI ? false : !isAdesao}
            />
        </div>
    );

    return (
        <>
            <Button
                style={{ marginBottom: '10px' }}
                label="Enviar Comprovante por E-mail"
                className="p-button-success"
                onClick={enviarEmail} />
            <Button
                label="Download pdf Comprovante"
                icon="pi pi-file-pdf"
                variant="contained"
                color="secondary"
                onClick={buscarPdf}
                className="p-button-info p-ml-auto" />

            {valuePdf && (
                <div style={{ height: '30px',
                    marginTop: '10px' }}>
                    <PDF dados={bodyPdf} />
                </div>
            )}
            {loadingEmail ? (
                <div className="LoadingWrapper">
                    <ProgressSpinner />
                </div>
            ) : (
                <div>
                    {sucesso && (
                        <Message
                            severity="success"
                            text="E-mail enviado com sucesso!"
                        />
                    )}
                    {erro && (
                        <Message
                            severity="error"
                            text="Ops, Falha ao enviar o E-mail"
                        />
                    )}
                </div>
            )}
            <Dialog
                header="Grupo Zelo"
                footer={footer}
                visible={isDialog}
                style={{ width: '50vw' }}
                modal={true}
                onHide={() => {}}
                dismissableMask
            >
                {isProgress ? (
                    <div>
                        <p>Valor da adesão:</p>
                        <InputNumber
                            value={adesaoValor}
                            onChange={e => setAdesao(e.target.value)}
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                            disabled
                        />
                    </div>
                ) : (
                    <div className="LoadingWrapper">
                        <ProgressSpinner />
                    </div>
                )}
            </Dialog>
        </>
    );
};

export default ValorAdesaoDinheiro;
